export default __webpack_public_path__ + "static/media/banner-5.f16e4fec.png";